export default function FAQSection() {
  const faqs = [
    {
      q: '星辰影院是否需要注册或付费？',
      a: '完全不需要！星辰影院是一个免费的电视剧在线观看平台，所有内容均可免费观看，无需注册、无需付费、无需会员。我们致力于为用户提供无障碍的追剧体验。',
    },
    {
      q: '星辰影院的电视剧画质如何？',
      a: '星辰影院所有电视剧均提供高清画质在线观看（720P/1080P），采用先进的视频编码技术，确保画面清晰细腻的同时保持流畅不缓冲的播放体验。',
    },
    {
      q: '如何在星辰影院搜索想看的电视剧？',
      a: '您可以通过网站顶部的搜索框直接搜索电视剧名称，也可以按照国产剧、港剧、韩剧、美剧等分类浏览。每个分类页面都提供了详细的筛选功能，帮助您快速找到心仪的剧集。',
    },
    {
      q: '星辰影院支持哪些设备观看？',
      a: '星辰影院采用响应式网页设计，完美兼容电脑、平板和手机等各类设备。无论您使用的是Windows、macOS、iOS还是Android系统，都可以流畅观看您喜欢的电视剧。',
    },
    {
      q: '星辰影院的电视剧更新速度如何？',
      a: '我们的编辑团队会在第一时间更新最新剧集。热播剧一般会在官方播出后24小时内更新，经典剧集也会持续补充完善，确保您不会错过任何精彩内容。',
    },
  ];

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  return (
    <section className="py-12 md:py-16 bg-background-100/50">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="max-w-[900px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            关于星辰影院的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group rounded-xl bg-background-100 border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none">
                <span className="text-sm md:text-base font-medium text-foreground-100 group-open:text-primary-400 transition-colors">
                  {faq.q}
                </span>
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-500 group-open:rotate-45 transition-transform duration-300">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}